import styled from "styled-components";

export const ImageWheelContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${({ $isHome }) => ($isHome ? "100vh" : "60vh")};

  @media (max-width: 361px) {
    height: ${({ $isHome }) => ($isHome ? "120vh" : "60vh")};
  }
`;

export const ImageWheel = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $isHome }) => ($isHome ? "100vh" : "60vh")};
  object-fit: cover;
  object-position: ${({ $isHome }) => ($isHome ? "center" : "50% 30%")};
  transition: opacity 0.5s ease-in-out;

  @media (max-width: 361px) {
    height: ${({ $isHome }) => ($isHome ? "120vh" : "60vh")};
  }

  ${({ $isActive }) => `
    opacity: ${$isActive ? 1 : 0};
    z-index: ${$isActive ? 1 : 0};
  `}
`;

export const ImageWheelGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $isHome }) => ($isHome ? "100vh" : "60vh")};
  background: linear-gradient(
    135deg,
    rgba(3, 26, 65, 1) 0%,
    rgba(0, 0, 255, 0) 100%
  );
  z-index: 1;
`;

export const TextCard = styled.div`
  position: absolute;
  left: 10%;
  transform: translateY(15.5%);
  color: white;
  padding: 20px;
  width: 90%;
  max-width: 600px;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  z-index: 2;
  display: ${({ $isHome }) => ($isHome ? "flex" : "block")};
  gap: 40px;
  flex-wrap: wrap;

  @media (max-width: 742px) {
    padding-right: 80px;
  }

  @media (max-width: 432px) {
    transform: translateY(5%);
  }
`;

export const TextCardButton = styled.div`
  background-color: #3393f0;
  padding: 25px 30px;
  color: white;
  border-radius: 30px;
  cursor: pointer;
  width: 240px;
  text-align: center;
  transition: background-color 0.6s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    margin-bottom: 10px;
    margin-right: 30px;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-right: 30px;
  }

  &:hover {
    background-color: rgb(5, 103, 201);
  }
`;

export const TextCardIntroTitle = styled.p`
  font-size: 16px;
  color: rgb(33, 100, 167);
  letter-spacing: 2px;
`;

export const TextCardTitle = styled.h1`
  display: block;
`;

export const TextCardText = styled.p`
  font-size: 18px;
  font-weight: normal;
`;

export const TextCardButtonLink = styled.a`
  text-decoration: none;
`;
